import { useEffect } from 'react';
import { overrideEmployeeIdb, OverrideEmployeeCacheKey } from '../services/cache/overrideEmployeeIdb';
import { DEFAULT_JOB_FAMILIES, Employee } from '../services/bonus/types';
import { bonusApi } from '../services/bonus/api';

export async function prefetchOverrideEmployees(jobFamily: string): Promise<Employee[]> {
    const key: OverrideEmployeeCacheKey = { jobFamily };

    const cached = await overrideEmployeeIdb.get(key);
    if (cached) return cached;

    const result = await bonusApi.getOverrideEmployees({ jobFamily });
    await overrideEmployeeIdb.set(key, result.employees);
    return result.employees;
}

export function useOverrideEmployeePrefetch(): void {
    useEffect(() => {
        prefetchOverrideEmployees(DEFAULT_JOB_FAMILIES).catch(console.error);
    }, []);
}